import BookingDiaryWeekEventComponentHtml from './booking-diary.week-event.html';

export const BookingDiaryWeekEventComponent : ng.IComponentOptions = {
  bindings: {
    event: '='
  },
  controller : 'BookingDiaryWeekEventCtrl',
  templateUrl: BookingDiaryWeekEventComponentHtml
};
